import * as React from 'react';

interface Props {
  children: React.ReactNode;
}

export const Message: React.FC<Props> = (props) => {
  return <div className="flex items-center space-x-2">{props.children}</div>;
};
Message.displayName = 'CustomerAssignment.Message';
